// src/pages/Home.js
import React from 'react';
import Hero from '../components/Hero';
import LearningEcosystem from '../components/LearningEcosystem';
import Contact from '../pages/Contact';
import Footer from '../components/Footer';
import About from './About';

function Home() {
  return (
    <div>
      <Hero />
      <LearningEcosystem />
      <About showFooter={false} />
      <Contact showFooter={false} />
      <Footer />
    </div>
  );
}

export default Home;